module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"add":"Neu","trainees":"Trainees"},"en":{"add":"Add","trainees":"Trainees"}}')
  delete Component.options._Ctor
}
